module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('transition', {
    attrs: {
      "name": _vm.transition
    },
    on: {
      "after-enter": _vm.handleAfterEnter,
      "after-leave": _vm.handleAfterLeave
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.disabled && _vm.showPopper),
      expression: "!disabled && showPopper"
    }],
    ref: "popper",
    staticClass: "el-popover el-popper",
    class: [_vm.popperClass, _vm.content && 'el-popover--plain'],
    style: ({
      width: _vm.width + 'px'
    }),
    attrs: {
      "id": _vm.tooltipId,
      "role": "tooltip",
      "aria-hidden": _vm.disabled || !_vm.showPopper ? 'true' : 'false'
    }
  }, [(_vm.title) ? _c('div', {
    staticClass: "el-popover__title",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("default", function() {
    return [_vm._v(_vm._s(_vm.content))]
  })], 2)]), _vm._v(" "), _c('span', {
    ref: "wrapper",
    staticClass: "el-popover__reference-wrapper"
  }, [_vm._t("reference")], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1cceb941"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/element-ui/packages/popover/src/main.vue
// module id = 2030
// module chunks = 228